import script from "./RecipeDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeDetails.vue?vue&type=script&setup=true&lang=js"

import "./RecipeDetails.vue?vue&type=style&index=0&id=4ac21005&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac21005"]])

export default __exports__